import tailorReducer from './reducers';

export default tailorReducer;
